<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @getTableData="getTableData" @btnclick="bthClick"
                :pageData="pageData"></table-page>
    <statistics :tableData="tableData" :totalize="totalize" ref="statistics"></statistics>
    <el-dialog
      :title="$t('mis.rewardDealList.refuse')"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <el-input type="textarea" :rows="4" :placeholder="$t('mis.rewardDealList.reason')" maxlength="100" show-word-limit v-model="reason"></el-input>
      <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('mis.rewardDealList.cancel')}}</el-button>
      <el-button type="primary" @click="cancel">{{$t('mis.rewardDealList.confirm')}}</el-button>
     </span>
    </el-dialog>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/views/mis/customerRelation/table.vue'
    import FORM from '../components/page/form.vue'
    import statistics from '../rebate/components/statistics.vue'
    import download from '@/utils/download'
    import Qs from 'qs'
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'

    let proposalStatus = {"1": "待审批", "2": "已成功"}
    let customerStatus = {0: "禁用", 1: "启用", 2: "注销"}
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            statistics
        },
        methods: {
            checkbox(row) {
                this.ids = row.map(key => key.id).join(",");
                this.proposals = row.map(key => key.proposalStatus).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "update") {
                    this.$refs.childUpdate.open(row);
                }
            },
            getTableData(tableData) {
                this.tableData = tableData;
                this.getTotalAmount();
            },
            /*总计*/
            getTotalAmount() {
                const param = Object.assign(JSON.parse(JSON.stringify(this.queryData)), {});
                this.$axios.get(URL.depositDetails.getTotalAmount, {
                    params: param
                }).then((res) => {
                    if (res.code == 0) {
                        this.totalize = res.result;
                    } else {
                        console.log(res.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            cancel() {
                this.dataChanage(URL.depositDetails.refuseProposal, {ids: this.ids,reason:this.reason}, res => {
                    this.handleClose();
                    if (res.code == 0) {
                        this.$message.success(window.$t('mis.accountReward.applySuccess'));
                        this.$refs.childTable.defaultGetData(this.queryData);
                    } else {
                        this.$message.error(window.$t('mis.accountReward.applyFail'));
                    }
                });
            },
            handleClose() {
                this.reason="";
                this.dialogVisible=false;
            },
            judge() {
                if (!this.proposals && this.proposals.length <= 0) {
                    this.$message({
                        message: window.$t('mis.accountReward.choiceOne'),
                        type: 'warning'
                    });
                    return false;
                }
                if ((this.proposals.indexOf("0") != -1) || this.proposals.indexOf("2") != -1 || this.proposals.indexOf("3") != -1) {
                    this.$message({
                        message: window.$t('mis.accountReward.notSatisfiable'),
                        type: 'warning'
                    });
                    return false;
                }
                return true;
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName || window.$t('mis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                } else if (window.$t('mis.rewardDealList.cancel') == clickName) {
                    //校验
                    if(!this.judge()){
                        return;
                    }
                    this.dataChanage(URL.depositDetails.approvalProposal, {ids: this.ids}, res => {
                        if (res.code == 0) {
                            this.$message.success(window.$t('mis.accountReward.applySuccess'));
                            this.$refs.childTable.defaultGetData(this.queryData);
                        } else {
                            this.$message.error(window.$t('mis.accountReward.applyFail'));
                        }
                    });
                } else if (window.$t('mis.rewardDealList.refuseProposal') == clickName) {
                    //校验
                    if(!this.judge()){
                        return;
                    }
                    this.dialogVisible=true;

                } else if (window.$t('mis.bt.down') == clickName) {
                    //隐藏关键字段
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide: true});
                    download.exportExcel(URL.depositDetails.downloadList, param, "details");
                } else if (window.$t('mis.bt.export') == clickName) {
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
                    download.exportExcel(URL.depositDetails.downloadList, param, "details");
                } else if (window.$t('mis.rewardDealList.downloadLimit') == clickName) {
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
                    download.exportExcel(URL.depositDetails.downloadLimit, param, window.$t('mis.rewardDealList.limit'));
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model) {
                //根据是否包含id更新还是添加
                this.dataChanage(URL.depositDetails.edit, model, res => {
                    if (res.code == 0) {
                        this.$refs.childUpdate.close();
                        this.$message.success(window.$t('mis.rewardDealList.confirmSuccess'));
                        this.$refs.childTable.defaultGetData(this.queryData);
                    } else {
                        this.$message.success(window.$t('mis.rewardDealList.confirmFail'));
                    }
                })
            },
            dataChanage(url, option, suc, fail) {
                this.axios.post(url, Qs.stringify(option || {})).then(res => {

                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data() {
            return {
                ids: "",
                proposals: "",
                reason: "",
                dialogVisible: false,
                queryData: {},
                tableData: [],
                totalize: {},
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [
                        {title: window.$t('mis.common.startTime'), field: 'beginDate', type: 5,dateType:'date',format:'yyyy-MM-dd'},
                        {title: window.$t('mis.common.endTime'), field: 'endDate', type: 5,dateType:'date',format:'yyyy-MM-dd'},
                        {title: window.$t('mis.rewardDealList.currentCustomerNumber'), field: 'currentCustomerNumber'},
                        {title: window.$t('mis.rewardDealList.currentMobilePhone'), field: 'currentMobilePhone'},
                        {title: window.$t('mis.rewardDealList.customerStatus'), field: 'customerStatus', type: 2, optionList: customerStatus},
                        {title: window.$t('mis.rewardDealList.proposalStatus'), field: 'proposalStatus', type: 2, optionList: proposalStatus},
                        {title: '类型', field: 'activeType', data: 1, hidden: true},
                        {title: '数据类型', field: 'isproposal', data: 1, hidden: true},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.bt.down')},
                        {click: window.$t('mis.bt.export')},
                        {click: window.$t('mis.rewardDealList.downloadLimit')},
                        {click: window.$t('mis.rewardDealList.apply')},
                        {click: window.$t('mis.rewardDealList.refuseProposal')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.depositDetails.proposalList, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: window.$t('mis.rewardDealList.createDate'), field: 'createDate'},
                        {title: window.$t('mis.rewardDealList.currentCustomerNumber'), field: 'currentCustomerNumber'},
                        {title: window.$t('mis.rewardDealList.currentMobilePhone'), field: 'currentMobilePhone'},
                        {title: window.$t('mis.rewardDealList.currentChineseName'), field: 'currentChineseName'},
                        {
                            title: window.$t('mis.rewardDealList.customerStatus'), field: 'customerStatus', render: (data, full) => {
                                return customerStatus[data] || "";
                            }
                        },
                        {title: window.$t('mis.rewardDealList.currentRebete'), field: 'currentRebete'},
                        {title: window.$t('mis.rewardDealList.correctionRebete'), field: 'correctionRebete'},
                        {title: window.$t('mis.rewardDealList.finalRebete'), field: 'finalRebete'},
                        {
                            title: window.$t('mis.rewardDealList.proposalStatus'), field: 'proposalStatus', render: (data, full) => {
                                return proposalStatus[data] || "";
                            }
                        },
                        {title: window.$t('mis.rewardDealList.updateUser'), field: 'updateUser'},
                        {title: window.$t('mis.rewardDealList.updateDate'), field: 'updateDate'},
                        {title: window.$t('mis.rewardDealList.approvalUser'), field: 'approvalUser'},
                        {title: window.$t('mis.rewardDealList.approvedDate'), field: 'approvedDate'},
                        {title: window.$t('mis.rewardDealList.remark'), field: 'remark'},
                    ]
                }
            }
        }
    }
</script>
